module.exports = __webpack_public_path__ + "img/logo.93502a42.png";